import { render, staticRenderFns } from "./TabNavigationRouteMenu.vue?vue&type=template&id=fbcd4c1e&"
import script from "./TabNavigationRouteMenu.vue?vue&type=script&lang=ts&"
export * from "./TabNavigationRouteMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports